import classnames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import styles from "./linkCard.module.scss";

function LinkCard(props: any) {
  const {
    title, onClick, className, subTitle, openClass, content = null, desktopView = false, fontSize,
  } = props;
  const { t } = useTranslation("product");

  return (
    <PAText
      component="h2"
      className={classnames({
        [styles.isOpen]: openClass,
        [styles.link_card]: true,
        [styles.link_card_desktop]: desktopView,
      }, className)}
      onClick={onClick}
      data-testid="overview-card"
      fontSize={fontSize || FONT_SIZE[5]}
      bold
      color="black"
    >
      {content ? (
        <>
          {t(title)}
          :
          {" "}
          {content}
        </>
      ) : <>{t(title)}</>}

      { subTitle ? <p>{subTitle}</p> : null }
    </PAText>
  );
}
export default LinkCard;
